import React from 'react';
import { BoxIcon } from 'lucide-react';
interface CertificationBadgeProps {
  icon: BoxIcon;
  title: string;
  description: string;
}
export function CertificationBadge({
  icon: Icon,
  title,
  description
}: CertificationBadgeProps) {
  return <div className="flex flex-col items-center text-center p-8 rounded-2xl bg-white border border-gray-100 hover:border-[#7E3007]/30 hover:shadow-xl transition-all duration-300 group h-full" data-id="element-13">
      <div className="p-5 rounded-full bg-gradient-to-br from-[#7E3007] to-[#5a2205] mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg" data-id="element-14">
        <Icon className="w-10 h-10 text-white" strokeWidth={1.5} data-id="element-15" />
      </div>
      <h3 className="text-[#4B280B] font-bold text-xl mb-3" data-id="element-16">{title}</h3>
      <p className="text-gray-600 text-sm leading-relaxed" data-id="element-17">{description}</p>
    </div>;
}